import { commitActivePatch } from "./commitActivePatch";
import {
  ITlfActionActivateVariantPatch,
  SET_VARIANT_CREATION_VIEW,
  SET_VARIANT_PATCH_SELECTION,
  TlfContextProps,
} from "./interface";
import { tlf_setVariantCreationMode } from "./tlf_setVariantCreationMode";
import { tlf_setVariantPatchSelection } from "./tlf_setVariantPatchSelection";
import { updateActivePatchErrors } from "./updateActivePatchErrors";

/**
 * Commits the current draft and makes an applied patch active for editing.
 *
 * @param state - Current TLF context state
 * @param action - Patch to activate
 * @returns State with the requested patch active
 */
export const tlf_activateVariantPatch = (
  state: TlfContextProps,
  action: ITlfActionActivateVariantPatch,
): TlfContextProps => {
  if (!state.appliedVariantPatches.includes(action.patchName)) return state;
  const { state: committedState, catalog } = commitActivePatch(state, action.calledFrom);
  if (catalog === null) return committedState;
  const creationState = tlf_setVariantCreationMode(committedState, {
    operation: SET_VARIANT_CREATION_VIEW,
    variantCreationView: true,
    calledFrom: action.calledFrom,
  });
  const newState = tlf_setVariantPatchSelection(creationState, {
    operation: SET_VARIANT_PATCH_SELECTION,
    appliedPatchNames: state.appliedVariantPatches,
    activePatchName: action.patchName,
    calledFrom: action.calledFrom,
  });
  return updateActivePatchErrors(newState);
};
